import { CityGuideRefreshRO } from '@routellers/types/dist/city-guide/city-guide-refresh.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = { id: number; data?: { force?: boolean } };

type ResponseData = CityGuideRefreshRO;

export const refreshGuide: ApiMethodDeclaration<ParamsData, ResponseData> = ({ id, data }) => ({
    url: `/cities/${id}/refresh-guide`,
    method: 'POST',
    data: data || {},
});
